<template>
  <el-row v-if="tableData != ''">
    <el-card>
      <div slot="header">
        <div>配货明细</div>
        <div v-if="type === 'add'" style="margin-top: 5px">
          <div style="display: inline-table">
            <el-input
              placeholder="请输入商品69码、名称"
              size="small"
              v-model="keyValue"
              ref="input"
              clearable
            >
            </el-input>
            <!-- <template slot-scope="scope"> -->
            <el-button
              type="primary"
              size="small"
              style="margin-left: 10px"
              plain
              @click="search()"
              >查询</el-button
            >
            <!-- </template> -->
          </div>
          <div style="display: inline-table; float: right">
            <el-input
              v-model="snCode"
              placeholder="请输入SN码"
              size="small"
              clearable
              @keyup.enter.native="handleData"
            >
            </el-input>
            <el-button
              @click="handleData"
              type="primary"
              size="small"
              style="margin-left: 10px"
              plain
              >添加
            </el-button>
          </div>
        </div>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="spec" label="类别" width="180">
        </el-table-column>
        <el-table-column prop="goodsName" label="商品名称" width="180">
          <template slot-scope="scope">{{filterStr(scope.row.goodsName)}}</template>
        </el-table-column>
        <el-table-column prop="skuCode" label="SKU编码"> </el-table-column>
        <el-table-column prop="barCode" label="69码"> </el-table-column>
        <el-table-column prop="quantity" label="下单数量"> </el-table-column>
        <el-table-column
          prop="snQuantity"
          label="已录入SN码数量"
          style="color: red"
        >
          <template slot-scope="scope">
            <span class="snQuantityRed">{{ scope.row.snQuantity }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="金额"> </el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="look(scope.row)"
              >查看SN详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog title="查看SN详情" :visible.sync="showDialog" width="30%">
      <span>商品名称：{{ filterStr(goodsNames)}}</span>
      <el-table :data="snList" height="300" border>
        <el-table-column prop="snNo" label="sn码"></el-table-column>
        <el-table-column
          width="70"
          v-if="orderInfo.waybillStatus == '2'"
          prop="price"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="closeOrder(scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 关闭订单的弹窗 -->
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>确定删除此sn吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="removeGoods">确 定</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import { orderPdApi } from "@/modules/server-api/orderPd/order";
import { getPrepareList } from "@/modules/server-api/prepare/prepare";
export default {
  name: "detailList",
  props: {
    type: {
      type: String,
    },
    orderInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      gridData:[],//弹窗-显示sn码的表格
      goodsNames:'',//商品名称
      showDialog:false,
      tableData: [],
      keyValue:'',
      snCode: null,
      list:[],//保存输入的sn码
      tableList:[],
      goodsLists:[],
      snList:[],//存储输入的sn码
      snIndex:'',
      dialogVisible:false,
      orderNo:""
    };
  },
  methods: {
    addDetails(data, orderNo) {
      // this.tableData = data;
      // 临时存储表格信息tableList
      this.tableList = data;
      this.orderNo=orderNo
      // console.log('888888',data)
      // console.log('888888',data)
      data.map((item) => {
        // 如果数量不为零--才添加显示
        if (item.quantity != "0") {
          item.price = item.price ? item.price : 0;
          item.snQuantity = item.snQuantity ? item.snQuantity : 0;
          // console.log( 'item', item)
          this.tableData.push(item);
          return item;
        }
        // else{
        //     return
        // }
      });
      console.log("addDetails", this.tableData);
    },
    //添加SN添加到配货明细中
    handleData() {
      // console.log('handleData', this.snCode)
      let currResult = this.snCode;
      // let i = 0
      //    if(this.snList.length>0){
      //     //    判断sn码的数组中有值的话，是否已经录入过
      //        for (let item of this.snList){
      //            if(item == this.snCode){
      //                 // this.$notifyError('sn码已经录入55');
      //                 return true
      //                 i = 1
      //                 break;
      //            }
      //        }
      //       if(i!=1){
      //           console.log('进来了1',i,this.snList)
      //           this.check(currResult)
      //       }
      //    }
      //    else{
      //    console.log('进来了2',i,this.snList)
      this.check(currResult);
      // }
    },
    // 搜索
    search() {
      let that = this;
      //  console.log('row',this.input)
      if (that.keyValue == "") {
        that.addDetails(that.tableList);
      } else {
        let tableData = [];
        that.tableData.map((item) => {
          if (item.barCode == that.keyValue) {
            tableData.push(item);
            return;
          } else if (item.goodsName == that.keyValue) {
            tableData.push(item);
            return;
          }
        });
        that.tableData = tableData;
      }
    },
    //添加SN校验
    addSnList(skuCode, snCodeList) {
      // console.log('===添加SN=====', snCodeList);
      let currSN = this.currSnCode;
      this.currSnCode = "";
      //校验SN码是否已经存在
      let existsSn = false;
      let passFlag = true;
      let existsSku = false;
      this.goodsLists = this.tableData.map((item) => {
        if (skuCode === item.skuCode) {
          // item.sendNum = item.sendNum || 0;
          // console.log('item.sendNum',item.sendNum)
          existsSku = true;
          // let finalNum = Number(item.sendNum) + Number(snCodeList.length);
          if (item.snQuantity + 1 > item.quantity) {
            //已录入数量不能超过订单数量
            passFlag = false;
            // this.$nextTick(() => {
            // this.$notifyError('已录入数量不能超过订单数量~');
            // });
          } else {
            let snTipTitle = "";
            // console.log("snlit=====", item.snList);
            // console.log("isReceive===", this.isReceive);
            //发货改为不扫码，不存储SN码，故修改sn校验逻辑 灵蝶20210305
            // if(this.isReceive && item.snList.length > 0){//收货校验sn码是否在订单中
            item.snList = item.snList ? item.snList : [];
            if (item.snList.length > 0) {
              item.snList.map((sn) => {
                // if(sn == snCode){
                //   existsSn = true;
                // }
                const snExistsIndex = snCodeList.findIndex(
                  (snCode) => snCode == sn
                );
                if (snExistsIndex != -1) {
                  existsSn = true;
                }
              });
              snTipTitle = existsSn ? "当前SN码已存在" : "";
            }

            //因为总部给省代发货的时候目前没有SN码，暂时注释校验逻辑
            //发货校验sn码是否在扫描的list中
            // if(this.isReceive){//收货校验sn码是否在订单中
            //   // item.snOriginList.map(sn =>{
            //   //   if(sn == result){
            //   //     existsSn = true;
            //   //   }
            //   // })
            //   // snTipTitle = existsSn ? '': '当前SN码不在此订单中';
            // }else {
            //   //发货校验sn码是否在扫描的list中
            //   if(item.snList.length > 0){
            //     item.snList.map(sn =>{
            //       if(sn == snCode){
            //         existsSn = true;
            //       }
            //     })
            //     snTipTitle = existsSn ? '当前SN码已存在，请确认' : '';
            //   }
            // }
            // console.log("snTipTitle===", snTipTitle);
            if (snTipTitle != "") {
              passFlag = false;
              // this.$notifyError(snTipTitle);
            } else {
              // console.log("扫码成功添加到snList中");

              //      let data = {
              //             snNo:this.snCode,
              //             orderNo:this.$route.query.orderNo
              //         }
              // //  添加sn码
              //     getPrepareList.AddData(data).then(res=>{
              //         console.log('999',res)
              //         if(res.code == 200){
              //             this.$notifySuccess('添加成功');
              //             this.tableData.map((item,index)=>{
              //                 console.log('index',index)
              //                 item.snQuantity = item.snQuantity+1
              //             })
              //         }else if(res.code == 201){
              //             this.$notifyError(res.result);
              //         }
              //       })
              //item.snList.push(snCode);
              //item.sendNum++;
              snCodeList.map((sn) => {
                // console.log('====sn===sn===sn', sn);
                item.snList.push(sn);
                item.sendNum++;
              });
            }
          }
        }
        return item;
      });
      //校验订单中是否有该商品
      if (!existsSku) {
        if (passFlag) {
          // console.log(951)
          this.$notifyError("该SN码对应商品不在该订单中，请确认：" + currSN);
        }
        passFlag = false;
      }
      if (passFlag) {
        //保存sn
        // this.saveOneSn(skuCode, snCodeList);
      }
    },
    // 校验
    check(currResult) {
      console.log("currResult", currResult);
      if (currResult != "" && currResult != null) {
        if (currResult.length !== 14) {
          // this.currSnCode = ''
          this.$notifyError("扫描SN码有误,sn码必须是14位");
        } else {
          orderPdApi.snQuery({ code: currResult, "orderSn": this.orderNo }).then((resp) => {
            // console.log(resp);
            if (resp.succ === 1) {
              let hasSaleFlag = false;
              let resData = resp.result;
              if (resData && resData.length > 0) {
                let currSnList = []; //存储所有sn码
                resData.map((it) => {
                  if (it.hasSale) {
                    hasSaleFlag = it.hasSale;
                  }
                  currSnList.push(it.snCode);
                });

                //判断是否已经核销过
                if (hasSaleFlag) {
                  this.currSnCode = "";
                  this.$notifyError("该sn码已核销，无法录入:" + currResult);
                } else {
                  let currCode = resData[0].skuCodeBox; //商品编码\
                  //添加SN:可能是多个
                  // console.log('===添加SN=====', currSnList);
                  // this.addSnList(currCode, currSnList);
                  let i = 0;
                  this.tableData.map((item, index) => {
                    // console.log('index',index)
                    // 判断sku码是否对应--对应就添加
                    if (item.skuCode == currCode) {
                      //    item.snQuantity = item.snQuantity+1
                      let data = {
                        skuCode: item.skuCode,
                        snNo: this.snCode,
                        orderNo: this.$route.query.orderNo,
                      };
                      let datas = {
                        orderNo: this.$route.query.orderNo,
                        snCode: this.snCode,
                        skuCode: item.skuCode,
                      };
                      if (item.snQuantity + 1 > item.quantity) {
                        this.$notifyError("已录入数量不能超过订单数量~");
                      } else {
                        if(resData.length > 1){
                          //  添加sn箱码
                          getPrepareList.AddDatas(datas).then((res) => {
                            console.log('888',res)
                            if (res.code == 200) {
                              // console.log('this.snList',this.snList)
                              this.tableData[index].snQuantity =
                                item.snQuantity + 1;
                              // this.snList.push({snCode:this.snCode})
                              this.$notifySuccess("添加成功");
                              this.snCode = "";
                            } else if (res.code != 200) {
                              this.snCode = "";
                              // this.$notifyError(res.result);
                              this.$notifyError(res.data);
                            }
                          });
                        }else if(resData.length == 1){
                          //  添加sn码
                          getPrepareList.AddData(data).then((res) => {
                            console.log('999',res)
                            if (res.code == 200) {
                              // console.log('this.snList',this.snList)
                              this.tableData[index].snQuantity =
                                item.snQuantity + 1;
                              // this.snList.push({snCode:this.snCode})
                              this.$notifySuccess("添加成功");
                              this.snCode = "";
                            } else if (res.code != 200) {
                              this.snCode = "";
                              this.$notifyError(res.data);
                            }
                          });
                        }
                      }
                    } else {
                      // i做计数，判断有几个不符合
                      i++;
                      // console.log('i',i)
                    }
                  });
                  // 判断不符合数是否和总数相同，相同就是所有的都不符合
                  if (i == this.tableData.length) {
                    this.snCode = "";
                    this.$notifyError("sn码与商品不匹配");
                    i = 0;
                  }
                }
              }
            } else {
              // this.handleScanFlag = false;
              this.currSnCode = "";
              this.$notifyError(resp.error);
            }
          });
        }
      } else {
        this.$notifyError("录入sn码不能为空~");
      }
    },
    // 查看sn码详情-打开弹窗
    look(row) {
      this.snList = [];

      let obj = {
        orderNo: this.$route.query.orderNo,
        skuCode: row.skuCode,
      };
      // this.goodsNames = row.goodsName
      getPrepareList.lookData(obj).then((res) => {
        console.log("res.data", res.data);
        if (res.code == 0) {
          this.showDialog = true;
          this.snList = res.data.map((item) => {
            this.goodsNames = item.goodsName;
            let obj = {};
            obj.snNo = item.snNo;
            obj.skuCode = item.skuCode;
            obj.orderNo = item.orderNo;
            return obj;
          });

          console.log("this.snList", this.snList);
        } else {
          this.$notifyError(res.error);
          // this.showDialog = false
        }
      });
    },
    // 删除
    removeGoods() {
      console.log("删除sn", 8);
      console.log("删除sn", this.snList[this.snIndex]);
      let obj = this.snList[this.snIndex];
      getPrepareList.deleteData(obj).then((res) => {
        console.log("删除sn", res);
        if (res.code == 0) {
          this.$notifySuccess("删除成功");
          this.showDialog = false;
          this.dialogVisible = false;
          location.reload();
          //  this.addDetails(this.tableList)
        } else {
          this.$notifyError(res.error);
        }
      });
    },
    closeOrder(index) {
      this.snIndex = index;
      this.dialogVisible = true;
    },
  },
  watch: {
    keyValue(val) {
      if (val == "") {
        this.addDetails(this.tableList);
      }
    },
  },
};
</script>

<style scoped>
.el-input {
  position: relative;
  font-size: 14px;
  display: inline-block;
  width: auto;
}
.snQuantityRed {
  color: red;
}
</style>
